import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c('div',{attrs:{"id":"notfound"}},[_c('div',{staticClass:"notfound"},[_c('div',{staticClass:"notfound-404"},[_c('h1',[_vm._v("404")])]),_c('h2',[_vm._v("PAGE NOT FOUND")]),_c('p',[_vm._v("The page you are looking for might have been removed had its name changed or is temporarily unavailable.")]),_c(VBtn,{attrs:{"large":"","depressed":""},on:{"click":_vm.home}},[_c(VIcon,{attrs:{"large":""}},[_vm._v("mdi-home-variant-outline")]),_vm._v("Back to homepage ")],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }